var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerShapeCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 172,
    viewBox: "0 0 169 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 123,
    cy: 49,
    r: 103,
    stroke: "#00C99C",
    strokeWidth: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerShapeCorner);
export default __webpack_public_path__ + "static/media/banner-shape-corner.d30d6dfae29567f706387a4aaa5deb63.svg";
export { ForwardRef as ReactComponent };